export enum APILink{
    LOGIN = '/api/v1/auth',
    RECONNECT = '/api/v1/auth/reconnect',
    VERIFY_2FA = '/api/v1/auth/verify',
    ME = '/api/v1/users/me',
    BROKER_ME = '/api/v1/brokers/me',
    INIT_PAYMENT = '/api/v1/payments/init',
    PAYMENT = '/api/v1/payments/$transactionID',
    LOGOUT = '/api/v1/users/logout',
    DASHBOARD_STATISTIC = '/api/v1/statistics/dashboard',
    BROKER_DASHBOARD = '/api/v1/statistics/dashboard/broker',
    GET_DEPOSIT_CHART = '/api/v1/statistics/deposit-chart',
    GET_WITHDRAW_CHART = '/api/v1/statistics/withdraw-chart',
    GET_LINEAR_CHART = '/api/v1/statistics/linear-chart',
    GET_SALES_CHART = '/api/v1/statistics/sales-chart',
    GET_SYSTEM = '/api/v1/system',
    RESET_BROKER_TOKEN = '/api/v1/users/$user/broker/token',
    GET_REPORTING_SCHEMA_ROLES = '/api/v1/roles/schema',
    GET_ROLES = '/api/v1/roles',
    UPDATE_ROLE = '/api/v1/roles/$role',
    GET_LANGUAGES = '/api/v1/languages',
    GET_LANGUAGE = '/api/v1/languages/$language',
    GET_COUNTRIES = '/api/v1/countries',
    GET_COUNTRY = '/api/v1/countries/$country',
    GET_CURRENCIES = '/api/v1/currencies',
    GET_CURRENCY = '/api/v1/currencies/$currency',
    GET_REGIONS = '/api/v1/regions',
    GET_REGIONS_SHORT_LIST = '/api/v1/regions/short',
    GET_REGION = '/api/v1/regions/$region',
    GET_ROLE_LIMITS = '/api/v1/payout-limits/$limit/roles',
    GET_PAYOUT_LIMITS = '/api/v1/payout-limits',
    GET_PAYOUT_LIMITS_DATA = '/api/v1/payout-limits/list',
    GET_PAYOUT_LIMIT_CURRENCIES = '/api/v1/payout-limits/currencies',
    UPDATE_PAYOUT_LIMIT = '/api/v1/payout-limits/$limit',
    GET_LOGS = '/api/v1/logs',
    GET_LOGS_ACTIVITIES = '/api/v1/logs/activities',
    GET_USERS_LIST = '/api/v1/users/list',
    GET_PERMISSIONS = '/api/v1/permissions',
    GET_SHORT_ROLES = '/api/v1/roles/list',
    GET_ALLOWED_ROLES = '/api/v1/roles/allowed',
    GET_USERS = '/api/v1/users',
    GET_USER = '/api/v1/users/$user',
    UPLOAD_AVATAR = '/api/v1/profile/avatar',
    SWITCH_2FA = '/api/v1/profile/2fa',
    CONFIRM_2FA = '/api/v1/profile/confirm',
    RESET_2FA = '/api/v1/users/$id/reset',
    SET_WIRE = '/api/v1/brokers/wire',
    SET_BROKER_LINKS = '/api/v1/brokers/links',
    GET_PROVIDERS = '/api/v1/providers',
    UPDATE_BULK_PROVIDERS = '/api/v1/providers/bulk',
    GET_PROVIDER = '/api/v1/providers/$provider',
    UPDATE_PROVIDER_CREDENTIALS_INPUTS = '/api/v1/providers/$provider/inputs/credentials',
    UPDATE_PROVIDER_CLIENT_INPUTS = '/api/v1/providers/$provider/inputs/client',
    GET_PAYMENT_METHODS = '/api/v1/payment-methods',
    BULK_PAYMENT_METHODS_STATUS = '/api/v1/payment-methods/bulk/status',
    BULK_PAYMENT_METHODS_TYPE = '/api/v1/payment-methods/bulk/type',
    BULK_PAYMENT_METHODS_COUNTRIES = '/api/v1/payment-methods/bulk/countries',
    BULK_PAYMENT_METHODS_CURRENCIES = '/api/v1/payment-methods/bulk/currencies',
    BULK_PAYMENT_METHODS_OPEN = '/api/v1/payment-methods/bulk/open-new-tab',
    BULK_PAYMENT_METHODS_PROVIDER = '/api/v1/payment-methods/bulk/provider',
    GET_PAYMENT_METHOD_TYPES = '/api/v1/payment-methods/types',
    GET_PAYMENT_METHOD = '/api/v1/payment-methods/$country',
    UPDATE_PAYMENT_METHOD = '/api/v1/payment-methods/$paymentMethod',
    GET_COUNTRIES_SHORT_LIST = '/api/v1/countries/short',
    GET_BROKER_PAYMENT_METHODS = '/api/v1/broker-payment-methods/$user',
    SET_SORTING_ORDER = '/api/v1/broker-payment-methods/order',
    SWITCH_BROKER_PAYMENT_METHOD_STATUS = '/api/v1/broker-payment-methods/$user/$method/status',
    GET_BROKER_PAYMENT_METHOD_CREDENTIALS = '/api/v1/broker-payment-methods/$brokerPaymentMethod/credentials',
    GET_BROKER_PAYMENT_METHOD_COUNTRIES = '/api/v1/broker-payment-methods/$brokerPaymentMethod/countries',
    GET_BROKER_PAYMENT_METHOD_CASHIER = '/api/v1/broker-payment-methods/$brokerPaymentMethod/cashier',
    GET_BROKER_PAYMENT_METHOD_BANKS = '/api/v1/broker-payment-methods/$brokerPaymentMethod/banks',
    UPDATE_PASSWORD = '/api/v1/profile/password',
    GET_DEPOSIT_TRANSACTIONS = '/api/v1/reporting/deposit',
    GET_BROKERS_LIST = '/api/v1/reporting/brokers',
    GET_PAYMENT_METHODS_LIST = '/api/v1/reporting/methods',
    GET_REPORTING_TYPES = '/api/v1/reporting/types',
    GET_REPORTING_SCHEDULES = '/api/v1/reporting/schedules',
    GET_REPORTING_SUBSCRIPTIONS = '/api/v1/reporting/subscriptions',
    UPDATE_REPORTING_SUBSCRIPTION = '/api/v1/reporting/subscriptions/$subscription',
    UPDATE_REPORTING_SUBSCRIPTION_STATUS = '/api/v1/reporting/subscriptions/$subscription/status',
    GET_REPORTING_SUBSCRIPTION_JOBS = '/api/v1/reporting/subscriptions/$subscription/jobs',
    RESEND_CALLBACK = '/api/v1/reporting/deposit/$id/resend',
    GET_TRANSACTION_COLUMNS = '/api/v1/reporting/columns',
    DECLINE_CONFIRMATION = '/api/v1/confirmations/$confirmation/decline',
    APPROVE_CONFIRMATION = '/api/v1/confirmations/$confirmation/approve',
    SHARE_DEPOSIT_REPORT = '/api/v1/reporting/deposit/share',
    GET_DEPOSIT_TRANSACTION_DETAILS = '/api/v1/reporting/deposit/$id',
    GET_WITHDRAW_TRANSACTION_DETAILS = '/api/v1/reporting/withdraw/$id',
    GET_WITHDRAW_TRANSACTIONS = '/api/v1/reporting/withdraw',
    GET_WITHDRAW_PROVIDERS = '/api/v1/withdraws/providers',
    SHARE_WITHDRAW_REPORT = '/api/v1/reporting/withdraw/share',
    GET_PAYMENT_METHOD_CURRENCIES_LIST = '/api/v1/virtual-terminal/methods',
    GET_BROKER_ENABLED_METHODS = '/api/v1/users/$user/payment-methods',
    EMULATE_PAYMENT = '/api/v1/virtual-terminal/emulate',
    GET_WITHDRAW_BROKERS_LIST = '/api/v1/withdraws/brokers',
    GET_PAYABL_BANKS = '/api/v1/withdraws/payabl/banks',
    GET_WALLETTEC_METHODS = '/api/v1/withdraws/wallettec/methods',
    GET_WALLETTEC_BANKS = '/api/v1/withdraws/wallettec/banks',
    SEARCH_WITHDRAW_CLIENT = '/api/v1/withdraws/clients',
    MAKE_SAFECHARGE_WITHDRAW = '/api/v1/withdraws/safecharge',
    MAKE_BVNK_WITHDRAW = '/api/v1/withdraws/bvnk',
    MAKE_PAYABL_WITHDRAW = '/api/v1/withdraws/payabl',
    MAKE_MONETIX_WITHDRAW = '/api/v1/withdraws/monetix',
    MAKE_WALLETTEC_WITHDRAW = '/api/v1/withdraws/wallettec',
    MAKE_SKRILL_WITHDRAW = '/api/v1/withdraws/skrill',
    MAKE_B2BINPAY_WITHDRAW = '/api/v1/withdraws/b2binpay',
    MAKE_LIMEPAY_WITHDRAW = '/api/v1/withdraws/limepay',
    MAKE_AWEPAY_WITHDRAW = '/api/v1/withdraws/awepay',
    MAKE_UNIPAYMENT_WITHDRAW = '/api/v1/withdraws/unipayment',
    GET_WITHDRAW_COUNTRIES = '/api/v1/withdraws/countries',
    GET_WITHDRAW_TRANSACTION = '/api/v1/withdraws/transaction/$transaction',
    GET_SKRILL_CURRENCIES = '/api/v1/withdraws/skrill/$broker/currencies',
    GET_AWEPAY_BANKS = '/api/v1/withdraws/awepay/banks',
    GET_B2BINPAY_WALLETS = '/api/v1/withdraws/b2binpay/$broker/wallets',
    GET_BVNK_WALLETS = '/api/v1/withdraws/bvnk/$broker/wallets',
    GET_CONFIRMATIONS = '/api/v1/confirmations',
    GET_CONFIRMATIONS_FILTERS = '/api/v1/confirmations/filters',
    GET_TRANSLATIONS = '/api/v1/translations',
    DOWNLOAD_TRANSLATIONS = '/api/v1/translations/download',
    GET_SOURCES = '/api/v1/sources',
    GET_SHORT_SOURCES = '/api/v1/sources/list',
    GET_SOURCE = '/api/v1/sources/$source',
    GLOBAL_SEARCH = '/api/v1/search',
    UPDATE_ENCRYPTION_KEY = '/api/v1/system/key',
    UPLOAD_TRANSLATIONS = '/api/v1/translations/upload',
    GET_PASSKEY_OPTIONS = '/api/v1/profile/passkeys/options',
    REGISTER_PASSKEY = '/api/v1/profile/passkeys',
    GET_PASSKEY_LOGIN_OPTIONS = '/api/v1/auth/passkey/options',
    PASSKEY_LOGIN = '/api/v1/auth/passkey',
    GET_CALLBACKS = '/api/v1/reporting/callbacks',
    RESTART_CALLBACK = '/api/v1/reporting/callbacks/$id/restart',
    RESTART_CALLBACKS_QUEUE = '/api/v1/reporting/callbacks/restart-queue',
}
